import React from "react";
import { Button } from "react-bootstrap";
import { Well, PageTitle, PageContainer } from "./UI";
import firebase from "../../firebase";
// Firebase modular imports
import { getFirestore, doc, setDoc } from "firebase/firestore";

const db = getFirestore(firebase);

const ForcedRefresh: React.FC = () => {
	const handleClick = () => {
		const pubsubDocRef = doc(db, "product-pubsub", "product");
		let refreshTimestamp = new Date();
		setDoc(pubsubDocRef, { refreshAt: refreshTimestamp });
	};

	return (
		<PageContainer size="md" htmlPageTitle="Force Refresh">
			<PageTitle>Force Refresh</PageTitle>
			<Well>
				<p className="pb-2">Do you want to refresh the app for all users?</p>
				<Button variant="danger" className="btn-block text-center" onClick={handleClick}>
					Force Refresh
				</Button>
			</Well>
		</PageContainer>
	);
};

export default ForcedRefresh;
